import { setDefaultAudioLang } from '@/shared/components/player/store';

export default async ({ $i18n, $services }) => {
  const info = $services.resolve('info');
  const liveManager = $services.resolve('liveManager');
  const time = $services.resolve('time');
  const subscriber = $services.resolve('subscriber');
  const translations = $services.resolve('translations');
  let promise;

  const fetchTranslations = () => {
    if (promise) {
      return promise;
    }

    promise = translations.fetch()
      .then(() => {
        $i18n.setLocaleMessage(subscriber.currentLanguage, translations.data);
        $i18n.locale = subscriber.currentLanguage;
      }).finally(() => {
        promise = null;
      });

    return promise;
  };

  info.on('sync', () => setDefaultAudioLang(info.defaultLanguage));

  await info.fetch()
    .then(() => subscriber.fetch())
    .then(() => liveManager.init(time))
    .then(() => fetchTranslations())
    .then(() => setDefaultAudioLang(info.defaultLanguage));
};
